<style scoped="" type="text/css"></style>
<template>
	<el-button v-if="checkPower()" v-bind="omit($attrs, 'onClick')" :loading="loading" @click="handleClick">
		<slot></slot>
	</el-button>
</template>
<script type="text/javascript">
import Bury from '@/common/bury.js';

export default {
	name: 'yi_button',
	components: {},
	props: {
		code: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			loading: false,
		}
	},
	created() {
	},
	watch: {
	},
	mounted() {
	},

	methods: {
		omit(obj, keys) {
			const newObj = { ...obj };
			for (const key of keys) {
				delete newObj[key];
			}
			return newObj;
		},
		checkPower() {
			if (this.code == null) {
				return true;
			}
			if (this.code == '') {
				return true;
			}
			return this.utils.checkPower(this.code);
		},
		async handleClick() {
			//
			Bury.buryAdd({ functionType: '用户行为', logType: '按钮点击', startData: { 'code': this.code } });



			this.loading = true;
			try {
				await this.$attrs.onClick();
			} finally {
				this.loading = false;
			}
		},
	}
}
</script>
